import React, { Component } from 'react';
import * as $ from 'jquery';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import Clauses from './Clauses.js';
import ClausesEng from './ClausesEng.js';
import { LANG } from '../../App.js';

class TermsContainer extends Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps() {
    $('#content')[0].scrollIntoView();
  }

  renderClauses = (clause) => {
    if(this.props.lang === LANG.EN){
      return( <ClausesEng clause={clause}/> );
    }else{
      return( <Clauses clause={clause}/> );
    }
      
  }

  render() {
    const { t } = this.props;
    let clause = this.props.match.params.clause;
    return(
      <div>
        <div className="container-fluid" id="content">
          {this.renderClauses(clause)}
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(TermsContainer);



// WEBPACK FOOTER //
// ./src/guest/vcontract/TermsContainer.js